module.exports = __webpack_public_path__ + "img/others.057185d3.svg";